module.exports = __webpack_public_path__ + "img/GE.c8bb68bf.svg";